module.exports = __webpack_public_path__ + "img/chalice-yellow.7993550c.svg";